"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultDescriptor = void 0;
var defaultDescriptor = exports.defaultDescriptor = {
  writable: true,
  enumerable: true,
  configurable: false
};